// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"18":"bf1e9af0","234":"bf1e9af0","254":"bf1e9af0","336":"bf1e9af0","752":"bf1e9af0","842":"bf1e9af0","918":"bf1e9af0","928":"bf1e9af0","976":"bf1e9af0"}[chunkId] + ".chunk.css";
};